
import { useMemo } from 'react';

const FONT_MAP: Record<string, string> = {
  Arial: 'Arial, sans-serif',
  Bitter: '"Bitter", serif',
  BreeSerif: '"Bree Serif", serif',
  Carlito: '"Carlito", sans-serif',
  'EB Garamond': '"EB Garamond", serif',
  Inter: '"Inter", sans-serif',
  Lora: '"Lora", serif',
  'Noto Serif': '"Noto Serif", serif',
  Roboto: '"Roboto", sans-serif',
  'Source Sans': '"Source Sans Pro", sans-serif',
  Neuton: '"Neuton", serif',
};

const LINE_HEIGHT_MAP: Record<string, string> = {
  '1 Tight': '1',
  '1.15 Condensed': '1.15',
  '1.3 Standard': '1.3',
  '1.5 Relaxed': '1.5',
  '2 Spacious': '2',
};

export const getFontFamily = (fontType?: string): string | undefined =>
  fontType ? FONT_MAP[fontType] : undefined;

export const getLineHeight = (lineHeight?: string): string | undefined =>
  lineHeight ? LINE_HEIGHT_MAP[lineHeight] : undefined;

export interface TemplatePreviewSettings {
  font_size?: number | null;
  line_height?: string | null;
  text_font?: string | null;
  heading_font?: string | null;
  display_font?: string | null;
}

export interface PreviewStyleBundle {
  rootStyle: React.CSSProperties;
  headingFontFamily?: string;
  displayFontFamily?: string;
}

export const usePreviewSettings = (settings?: TemplatePreviewSettings | null): PreviewStyleBundle => {
  const rootStyle = useMemo<React.CSSProperties>(() => ({
    fontSize: settings?.font_size ? `${settings.font_size}pt` : undefined,
    lineHeight: getLineHeight(settings?.line_height ?? undefined),
    fontFamily: getFontFamily(settings?.text_font ?? undefined),
  }), [settings?.font_size, settings?.line_height, settings?.text_font]);

  const headingFontFamily = useMemo(
    () => getFontFamily(settings?.heading_font ?? undefined),
    [settings?.heading_font]
  );
  const displayFontFamily = useMemo(
    () => getFontFamily(settings?.display_font ?? undefined),
    [settings?.display_font]
  );

  return { rootStyle, headingFontFamily, displayFontFamily };
};
